export default "__VITE_ASSET__8cmScf72__"